import React from 'react'

type InteropProps = { className?: string }

type Layout = 'nodisplay' | 'fixed' | 'responsive' | 'fixed-height' | 'fill' | 'container' | 'flex-item' | 'intrinsic'
type Base = { layout?: Layout; on?: string; width?: number; height?: number }
type SelectorProps = Base & { id?: string; children?: React.ReactNode; role?: string }
type VideoProps = Base & { src?: string; noaudio?: boolean; autoplay?: boolean; loop?: boolean; crossorigin?: boolean }

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tab-selector': SelectorProps & { class?: string }
      'tab-video': VideoProps & { class?: string; layout: Layout }
    }
  }
}

const bool = <T extends object>(keys: (keyof T)[], props: T) =>
  keys.reduce((props, key) => ({ ...props, [key]: props[key] ? '' : undefined }), props)

// see: https://reactjs.org/docs/web-components.html
export const Selector = ({ className, ...props }: SelectorProps & InteropProps) => (
  <tab-selector class={className} {...props} />
)
export const Video = ({ className, layout = 'responsive', ...props }: VideoProps & InteropProps) => (
  <tab-video class={className} layout={layout} {...bool(['noaudio', 'autoplay', 'loop', 'crossorigin'], props)} />
)
